module.exports = __webpack_public_path__ + "static/media/stars-graphic.18ec23c0.png";